import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
    selector: 'loyaltic-email-reminder',
    templateUrl: './email-reminder.component.html',
    styleUrls: ['./email-reminder.component.scss'],
    standalone: false
})
export class EmailReminderComponent implements OnInit {

  email: any;
  emailSubmitted = false;

  constructor(private coreService: CoreService,
    private authService: AuthService, private router: Router,
    private toast: ToastrService, private translate: TranslateService, private route: ActivatedRoute) { }

  ngOnInit() {
  }

  onSubmit(formRef) {

    const body = {
      Email: this.email,
    };

    this.coreService.emailReminder(body).then((reminderResponse: any) => {
      formRef.submitted = false;
      localStorage.removeItem('inviterId');
      this.resetForm();
      const successMessage = this.translate.instant(reminderResponse.messageKey);
      this.toast.success(successMessage, 'Success');
      this.emailSubmitted = true;
    }).catch((errorResponse: any) => {
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage, 'Error');
      return;
    });
  }

  resetForm() {
    this.email = undefined;
  }

}
